import { IMAGE_MIME_TYPES, TEXT_MIME_TYPES } from "./constants";
import type {
  ApiAttachment,
  UserMessageAttachment,
  AttachmentItem,
} from "./types";

export const toCompletedAttachmentMeta = (
  attachments: AttachmentItem[],
): UserMessageAttachment[] =>
  attachments
    .filter(a => a.status === "completed")
    .map(({ id, filename, contentType, previewUrl }) => ({
      id,
      filename,
      contentType,
      previewUrl,
    }));

export const getExtensionFromFilename = (filename: string): string => {
  const parts = filename.split(".");
  return parts.length > 1 ? (parts.pop() ?? "") : "";
};

export const isImage = (contentType: string) =>
  IMAGE_MIME_TYPES.includes(contentType);

export const isText = (contentType: string) =>
  TEXT_MIME_TYPES.includes(contentType);

export const toListItem = (
  a: UserMessageAttachment | ApiAttachment,
): AttachmentItem => {
  if ("content_type" in a) {
    return {
      id: String(a.id),
      filename: a.filename,
      contentType: a.content_type,
      previewUrl: a.url,
    };
  }
  return {
    id: a.id,
    filename: a.filename,
    contentType: a.contentType,
    previewUrl: a.previewUrl,
  };
};
